import { useContext } from 'react';
import { useNavigation } from '@react-navigation/native';
import { AppContext } from '../../App';

export function useFormNavigation() {
  const { formProgress, setFormProgress } = useContext(AppContext);
  const navigation = useNavigation();

  const goToNextStep = (nextScreen) => {
    // Mark current step as completed
    const currentStep = formProgress.currentStep;
    if (!formProgress.completedSteps.includes(currentStep)) {
      setFormProgress(prev => ({
        ...prev,
        completedSteps: [...prev.completedSteps, currentStep],
        currentStep: nextScreen,
      }));
    } else {
      setFormProgress(prev => ({
        ...prev,
        currentStep: nextScreen,
      }));
    }
    
    navigation.navigate(nextScreen);
  };

  const updateCurrentStep = (step) => {
    setFormProgress(prev => ({
      ...prev,
      currentStep: step,
    }));
  };

  return { goToNextStep, updateCurrentStep, formProgress };
}